<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{'noteCategoryValue.'+noteCategoryId | translate}}</h4>

  <button type="button" class="btn-close" aria-label="Close" (click)="close()">

  </button>
</div>

<div class="modal-body">
  <!-- Listeleme -->
  <div class="card">
    <div class="card-body">
      <div class="row">
        <tabset [justified]="true" type="pills" *ngIf="showTab">
          <tab *ngFor="let item of noteTypes" [heading]="item.name" (selectTab)="onSelectTab(item)">
          </tab>
        </tabset>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <textarea class="form-control" name="notes" [(ngModel)]="notes" placeholder="{{'hint.enter-note' | translate}}" style="height: 80px"></textarea>
        </div>
        <div class="row">
          <app-note-item *ngFor="let note of dataList" [note]="note" [imageBaseUrl]="imageBaseUrl" (click)="addSelectedNote(note.name)" class="col-sm-12 col-md-6 col-lg-3"></app-note-item>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">

  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>
  <button type="button" class="btn btn-primary" (click)="save()">
    {{'button.save' | translate}}
  </button>

</div>